// 攪拌実施・作業実施タブ共通の小さな入力フィールド。

import { useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import { ExtendedDB } from "../../../types/extendedDB";
import type { ProcessExecutionBase } from "../../../schema/generated/ProcessExecution";
import { areaLabel, materialNamesForWorkDetail } from "./helpers";

// 工程実施の選択フィールド(工種/種別/工程 + 施工箇所表記)。攪拌では材料名も付記する。
export function PeSelectField({ db, pes, value, busy, onSelect, withMaterials }: {
  db: ExtendedDB; pes: ProcessExecutionBase[]; value: string; busy: boolean;
  onSelect: (peId: string) => void; withMaterials?: boolean;
}) {
  return (
    <TextField select size="small" label={withMaterials ? "配合比" : "工程"} sx={{ maxWidth: 640, minWidth: 320 }}
      value={value} error={value === ""} disabled={busy}
      onChange={(e) => { if (e.target.value !== "") { onSelect(String(e.target.value)); } }}>
      {pes.length === 0 && <MenuItem value="" disabled>(選択できる工程実施がありません)</MenuItem>}
      {pes.map((p) => {
        const wd = db.workDetails.find((w) => w.id === p.work_detail_id);
        const wst = wd?.work_subtype_id != null ? db.workSubtypes.find((s) => s.id === wd.work_subtype_id) : null;
        const wt = wst?.work_type_id != null ? db.workTypes.find((t) => t.id === wst.work_type_id) : null;
        const path = [wt?.name, wst?.name, wd?.name].filter((x): x is string => x != null && x.length > 0).join("/");
        let label = path === "" ? "?" : path;
        if (withMaterials) {
          const matNames = materialNamesForWorkDetail(db, p.work_detail_id);
          if (matNames.length > 0) {
            label = `${label} (${matNames.join(", ")})`;
          }
        }
        const area = areaLabel(db, p.construction_plan_area_id);
        return <MenuItem key={p.id} value={p.id}>{`${label}（${area}）`}</MenuItem>;
      })}
    </TextField>
  );
}

// 備考のローカル編集 + blur 保存。
export function RemarksField({ initial, busy, onSave }: { initial: string; busy: boolean; onSave: (v: string) => void }) {
  const [value, setValue] = useState(initial);
  return (
    <TextField size="small" label="備考" value={value} multiline minRows={1} disabled={busy}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => { if (value !== initial) { onSave(value); } }} />
  );
}
